const PrivacyContainer = () => {
  return (
    <div className="min-h-screen w-full relative bg-[#0d1117] overflow-x-hidden"
      style={{ backgroundImage: 'url("/backgrounds/bg-ice.png")', backgroundBlendMode: 'overlay' }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/20 via-transparent to-purple-900/20 pointer-events-none" />
      <header className="w-full min-h-10 px-5 py-10">
        <img className="mx-auto" src="/logos/ironpipeline.svg" alt="logo" />
      </header>

      <main className="max-w-4xl mx-auto p-4">
        <div
          className="relative px-6 sm:px-8 md:px-10 py-8 sm:py-10 md:py-12 rounded-lg border border-[rgba(81,81,81,0.4)] backdrop-blur-[15px]"
        >
          <div className="flex flex-col gap-6 sm:gap-8">
            <div className="text-center space-y-2">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-semibold text-white">
                Privacy Policy & Terms and Conditions
              </h1>
            </div>

            <div className="space-y-6 text-[#E5E7EB] leading-relaxed">
              <section className="space-y-4">
                <h2 className="text-xl sm:text-2xl font-semibold text-white mb-3">1. Acceptance of Terms</h2>
                <p className="text-sm sm:text-base">
                  These Terms of Service ("Terms") govern your access to and use of Iceberger ("Iceberger", "Company",
                  "we", "our") websites, services, and applications (collectively the "Site"). The Site includes, but
                  is not limited to iceberger.com. Please read these Terms in their entirety before using the Site. Your
                  access to and use of the Site is conditioned on your acceptance of and compliance with these Terms.
                  These Terms apply to all visitors, users, and others who access or use the Site.
                </p>
                <p className="text-sm sm:text-base">
                  You may use the Site only if you can form a binding contract with Iceberger, and only in compliance
                  with these Terms and all applicable local, state, national, and international laws, rules, and
                  regulations. The Site may change over time as we add more features and refine the Site, often and
                  without prior notice to you. In addition, Iceberger may temporarily or permanently stop providing the
                  Site, or any features within the Site, to you or to users of the Site in general and without prior
                  notice.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-xl sm:text-2xl font-semibold text-white mb-3">2. Site Visitors and Customers</h2>
                <p className="text-sm sm:text-base">
                  To purchase Iceberger's products and services, you must be at least 18 years of age. By using the
                  products and services provided by the Site, you represent and warrant that you are at least 18 years
                  old and that all registration information you submit is accurate and truthful. Iceberger may, in its
                  sole discretion, refuse to allow access to or use of the Site to any user.
                </p>
                <p className="text-sm sm:text-base">
                  This provision is void where prohibited by law, and the right to access the Site is revoked in such
                  jurisdictions. You agree to comply with all laws regarding online conduct. In addition, you must
                  abide by Iceberger's policies as stated in these Terms and other policy documents listed on the Site,
                  as well as all other operating rules, policies, and procedures that may be published from time to time
                  on the Site by Iceberger, each of which is incorporated herein by reference and each of which may be
                  updated by Iceberger from time to time without prior notice to you.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-xl sm:text-2xl font-semibold text-white mb-3">3. Account Registration and Security</h2>
                <p className="text-sm sm:text-base">
                  Several features on the Site require registration and creation of a member account. You must keep
                  account information up-to-date and accurate at all times, including a valid email address. Your
                  Iceberger account is your account only and you may not share, transfer, or sell your account or User
                  ID to any other party. You must treat your account information as confidential and personal to you.
                </p>
                <p className="text-sm sm:text-base">
                  Keep your password secure. Do not provide your username or password information to any other party.
                  You agree that you are fully responsible for any and all activity, liability, and damage resulting from
                  your failure to maintain password confidentiality. You also agree that Iceberger cannot and will not be
                  liable for any loss or damage arising from your failure to keep your password secure.
                </p>
                <p className="text-sm sm:text-base">
                  You agree to notify Iceberger immediately in the event of any unauthorized use of your password or any
                  breach of security. Iceberger reserves the right to refuse or suspend service to anyone, for any
                  reason, at any time, including in the event of your actual or suspected unauthorized use of the
                  services or non-compliance with these Terms of Use or other Iceberger policies. Iceberger reserves the
                  right, in its sole discretion, to cancel unconfirmed or inactive accounts.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-xl sm:text-2xl font-semibold text-white mb-3">4. Terms of Sale</h2>
                <p className="text-sm sm:text-base">
                  Use of the software (products and services) offered on the Site requires payment of a subscription fee
                  (unless otherwise stated). All prices and fees are quoted in US Dollars (USD). If you elect to
                  subscribe for our services, you shall pay all applicable fees, as described on the Site. All fees are
                  exclusive of state and local sales or use taxes and any duties imposed by taxing authorities, and you
                  shall be responsible for payment of all such taxes. You agree to pay any such taxes that might be
                  applicable to your use of the services and payments made to Iceberger.
                </p>
                <p className="text-sm sm:text-base">
                  Iceberger reserves the right to change its prices at any time, and any such changes or modifications
                  shall be posted on the Site and effective immediately (notices to any user are at the discretion of
                  Iceberger). Any such changes or modifications in prices and fees shall be effective when the services
                  in question come up for renewal.
                </p>
                <p className="text-sm sm:text-base">
                  You authorize Iceberger, directly or through third parties, to make any inquiries it considers
                  necessary to validate your account and financial information you provide. All fees relating to usage
                  of the services are charged automatically using the payment method (Credit card/PayPal) specified by
                  you on file with Iceberger for your user account. Iceberger does not maintain payment information from
                  users that purchase our products and services. User credit card information is maintained and
                  processed through Iceberger's credit card processor Stripe.
                </p>
                <p className="text-sm sm:text-base">
                  If you are on a subscription plan, it will automatically renew at the end of the subscription period
                  unless you cancel before the end of the current subscription period. For complete subscription plan
                  details, view Iceberger's refund policy. Until Iceberger receives a request from you regarding the
                  status of your subscription, you acknowledge and understand that Iceberger will continue to charge you
                  as long as your account remains active, regardless of whether the services are used or not.
                </p>
                <p className="text-sm sm:text-base">
                  Iceberger will not refund any subscription fees already paid to us. You shall not have any claims
                  against Iceberger in relation to the discontinuation of the services. All prices and fees are
                  non-refundable unless otherwise expressly noted (review the Iceberger refund policy for complete
                  details), even if the services are suspended or terminated prior to the end of a payment term. If, at
                  any time, you contact your bank or credit card company and decline or otherwise reject the charge of
                  any payable fees, this act will be considered a breach of your obligations hereunder and your use of
                  the services will be automatically terminated.
                </p>
                <p className="text-sm sm:text-base">
                  If you have any questions concerning your order, please contact us using the contact information listed
                  at the bottom of this document.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyContainer;
